import { render, staticRenderFns } from "./ImportanceQuestion.vue?vue&type=template&id=0c5ce322&scoped=true&"
import script from "./ImportanceQuestion.vue?vue&type=script&lang=ts&"
export * from "./ImportanceQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./ImportanceQuestion.vue?vue&type=style&index=0&id=0c5ce322&lang=scss&scoped=true&"
import style1 from "./ImportanceQuestion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ce322",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VScrollYTransition,VSpacer,VTextField,VTextarea,VTooltip})
